import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import classNames from 'classnames';
import Cookies from 'js-cookie'

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			options: [],
			selected: null,
			redirect: false,
			value: '',
			suggestions: [],
			isLoading: false,
			showBanner: false,
			currentLocation: '',
			cookieValue: Cookies.get('COOKIEPOLICY')
		};

		this.lastRequestId = null;

	}

	componentDidMount() {
		var cookieValue = this.state.cookieValue;

		if (cookieValue === 'true') {
			this.setState({ showBanner: false });
		} else {
			this.setState({ showBanner: true });
		}
	}

	handleCookieClick(e) {
		e.preventDefault();
		Cookies.set('COOKIEPOLICY', 'true', {expires: 365, secure: true, sameSite: 'strict'});
		this.setState({ showBanner: false });

	}


	render() {
		if(this.state.showBanner) {

			return (


				<div id="cookie-notification" 				
					className={
						classNames(
							'show',
							{
							'mobile-nav-visible': this.state.showBanner
						})
				}>
					<div class="row">
						<div class="col">
						<p class="reduced">We use cookies on this website. We use these cookies to enhance your user experience, improve the quality of our site, and to show you marketing that is more likely to be relevant to your interests. We also allow third parties, including our advertising partners, to place cookies on our websites. By continuing to use this website, you consent to the placement and use of cookies as described in our <a id="privacy" href="https://www.masterlock.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>. If you would like to disable the use of all cookies, including those placed by advertisers, please use your browser&rsquo;s settings to reject cookies on this site.</p>
							<a id="cookie-notification-close" href="#" onClick={ e => this.handleCookieClick(e) } title="close">Accept</a>
						</div>
					</div>
				</div>


			);
		} else {
			return(<div></div>);
		}
	}


}

export default branch({
}, Header);



// WEBPACK FOOTER //
// ./src/pages/components/Cookie.js